export const REACT_APP_BASE_URL = "https://kuasky.com";
export const ORIGINAL_PRODUCT_ID = 13879;
export const FROM_EMAIL = 'Kua Sky  <custom@kuasky.com>';
export const TO_EMAIL = 'info@kuasky.com';
export const CC_EMAIL = 'info@threeringdev.com';
export const EMAIL_SUBJECT = 'Custom Suit Order for:';
export const WC_BASIC_AUTH = 'Basic Y2tfNWYzMWIwODRjMDNkMTgzZDBmY2RiNjIxZWM4YjIwNTg1OGIyNzRiNDpjc182NmY5MjQ3YWMxYjBmZTA1ZDBjYTkzOTBiMWJlYjBjNmE3ZDEwM2Jj';
export const CAPTCHA_SITE_KEY  = "6LeBNeQnAAAAAHOf0xZqpOaNDZ5dMTa4hNb8Ivm0";
export const CAPTCHA_SECRET_KEY  = "6LeBNeQnAAAAAEu2ttNedjY2nqZIUozwSJjKdEFi";
export const MAIN_PRICE = 470;
export const PATTERN_PRICE = 75;
export const GRIPPER_PRICE = 50;
export const RDS_POCKET_PRICE = 45;
export const CELL_PHONE_POCKET = 30;